/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import ContainerHome24 from '../../atoms/ContainerHome24';
import WhiteButton from '../../atoms/WhiteButton/WhiteButton';
import Styles from './EmprestimoGarantiaCarroBannerAbr26.css';
import RedButton from '@/components/atoms/RedButton';

function EmprestimoGarantiaCarroBannerAbr26() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="hero-santander-financiamentos">
        <ContainerHome24>
          <div className="hero-img">
            {typeof window === 'undefined' ? (
              <></>
            ) : (
              <>
                {width <= 449 && (
                  <img
                    src="assets/emprestimo-garantia-carro\hero-abr-26/img-312.png"
                    alt="Pessoa encostada em veículo dado com celular em mãos pesquisando sobre Empréstimo com Garantia de Veículo na Santander Financiamento."
                    className=""
                  />
                )}
                {width > 449 && width <= 599 && (
                  <img
                    src="assets/emprestimo-garantia-carro\hero-abr-26/img-450.png"
                    alt="Pessoa encostada em veículo dado com celular em mãos pesquisando sobre Empréstimo com Garantia de Veículo na Santander Financiamento."
                    className=""
                  />
                )}
                {width > 599 && width <= 799 && (
                  <img
                    src="assets/emprestimo-garantia-carro\hero-abr-26/img-600.png"
                    alt="Pessoa encostada em veículo dado com celular em mãos pesquisando sobre Empréstimo com Garantia de Veículo na Santander Financiamento."
                    className=""
                  />
                )}
                {width > 799 && width <= 1100 && (
                  <img
                    src="assets/emprestimo-garantia-carro\hero-abr-26/img-800.png"
                    alt="Pessoa encostada em veículo dado com celular em mãos pesquisando sobre Empréstimo com Garantia de Veículo na Santander Financiamento."
                    className=""
                  />
                )}
                {width > 1100 && (
                  <img
                    src="assets/emprestimo-garantia-carro\hero-abr-26/img-1280.png"
                    alt="Pessoa encostada em veículo dado com celular em mãos pesquisando sobre Empréstimo com Garantia de Veículo na Santander Financiamento."
                    className=""
                  />
                )}
              </>
            )}
          </div>
          <div className="hero-contain">
            {/* <div className="hero-selo">
              <img src="assets/mes-do-ambiente/home/img-selo.svg" alt="" className="" />
            </div> */}
            <div className="hero-texts">
              <h1 className="hero-title">Empréstimo com Garantia de Veículo</h1>
              <h2 className="hero-sub-title">
                Use seu carro quitado para conseguir um fôlego financeiro com taxas a partir de
                1,39% a.m.
              </h2>
            </div>
            <div className="hero-buttons">
              <WhiteButton
                href="https://emprestimosim.com.br/app/#/onboarding/signUp"
                id="hero-button-simular-financiamento"
                wide
                target="_blank"
              >
                Simular agora
              </WhiteButton>
              <RedButton
                href="https://emprestimosim.com.br/app/#/login/signInWithPassword"
                id="hero-button-simular-financiamento"
                wide
                target="_blank"
              >
                Entrar
              </RedButton>
            </div>
          </div>
        </ContainerHome24>
        <style jsx>{Styles}</style>
      </section>
    </>
  );
}

export default EmprestimoGarantiaCarroBannerAbr26;
